import { Component, OnDestroy, Input, OnChanges } from "@angular/core";
import {
  trigger,
  state,
  transition,
  style,
  animate,
} from "@angular/animations";
import { ConversationMeta } from "../../Models/conversation.interface";
import { BehaviorSubject, Subject } from "rxjs";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { Profile } from "src/app/Models/profile.interface";
import { AngularFireDatabase } from "@angular/fire/database";
import _ from "lodash";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
@Component({
  selector: "app-messages",
  templateUrl: "./messages.component.html",
  styleUrls: ["./messages.component.css"],
  animations: [
    trigger("allMessages", [
      state(
        "void",
        style({ opacity: 0, display: "none", transform: "translateX(-10%)" })
      ),
      state(
        "allMessages",
        style({ opacity: 1, display: "*", transform: "translateX(0%)" })
      ),
      state(
        "expandedMessage",
        style({ opacity: 0, display: "none", transform: "translateX(-10%)" })
      ),
      transition("void => *", [animate("200ms ease-in-out")]),
      transition("allMessages => expandedMessage", [
        animate("200ms  ease-in-out"),
      ]),
      transition("expandedMessage => allMessages", [
        animate("200ms  ease-in-out"),
      ]),
      transition("* => void", [animate("200ms ease-in-out")]),
    ]),
    trigger("expandedMessage", [
      state(
        "void",
        style({ display: "none", opacity: 0, transform: " translateX(10%)" })
      ),
      state(
        "allMessages",
        style({ display: "none", opacity: 0, transform: "translateX(10%)" })
      ),
      state(
        "expandedMessage",
        style({ display: "*", opacity: 1, transform: "translateX(0%)" })
      ),
      transition("void => *", [animate("200ms ease-in-out")]),
      transition("allMessages => expandedMessage", [
        animate("200ms ease-in-out"),
      ]),
      transition("expandedMessage => allMessages", [
        animate("200ms ease-in-out"),
      ]),
      transition("* => void", [animate("200ms ease-in-out")]),
    ]),
    trigger("profile", [
      state("void", style({ opacity: 0, display: "none" })),
      state("show", style({ opacity: 1 })),
      transition("* => *", [animate("200ms ease-in-out")]),
    ]),
  ],
})
export class MessagesComponent implements OnDestroy, OnChanges {
  @Input() authLevel: string;
  @Input() orgId: string;
  @Input() orgName: string;
  @Input() entityId: string;
  config;
  expandedMessageTrigger = "allMessages";
  allMessagesTrigger = "allMessages";
  profileTrigger = "void";
  selectedProfile;
  selectedConversationSubject = new BehaviorSubject<ConversationMeta>(null);
  profile: Profile;
  leaving = new Subject();
  change = new Subject();
  org;
  constructor(
    private db: AngularFireDatabase,
    private um: UserManager,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngAfterViewInit() {
    setTimeout(this.setup, 0);
  }

  setup = () => {
    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .takeUntil(this.change)
      .subscribe((profile) => {
        if (!_.isEqual(profile, this.profile)) {
          this.profile = profile;
          if (!profile) {
            return;
          }
          if (!this.entityId) {
            this.entityId = profile.entityId;
          }
          if (!this.authLevel && profile.entityId) {
            this.db
              .list("Organizations", (ref) =>
                ref.orderByChild("entityId").equalTo(profile.entityId)
              )
              .snapshotChanges()
              .take(1)
              .subscribe((actions) => {
                if (actions && actions.length > 0) {
                  this.db
                    .object(`Permissions/${actions[0].key}`)
                    .valueChanges()
                    .take(1)
                    .subscribe((org) => this._checkAccess(org));
                }
              });
          }
        }
      });
  };

  ngOnDestroy(): void {
    this.leaving.next(null);
  }

  ngOnChanges(change) {
    this.change.next();
    this.setup();
  }

  _checkAccess = (org) => {
    let { uid } = this.profile;
    if (!org) {
      return;
    }
    if (_.has(org, `Admins[${uid}]`)) {
      this.authLevel = "admin";
    } else if (_.has(org, `Instructors[${uid}]`)) {
      this.authLevel = "instructor";
    }
    // console.log(org, this.authLevel)

    if (this.authLevel) {
      console.log("getting org");
      this.db
        .object(`Organizations/${this.orgId}`)
        .valueChanges()
        .takeUntil(this.leaving)
        .subscribe((o) => {
          this.org = o;
        });
    }
  };

  toggle() {
    // console.log(`${this.allMessagesTrigger}`)
    if (this.allMessagesTrigger === "allMessages") {
      this.allMessagesTrigger = "expandedMessage";
    } else {
      this.allMessagesTrigger = "allMessages";
    }
    // console.log(`${this.allMessagesTrigger}`)
  }

  openConversation(conversation: ConversationMeta) {
    this.selectedConversationSubject.next(conversation);
    this.allMessagesTrigger = "expandedMessage";
  }

  openConversationEnd(e) {
    if (e.toState === "expandedMessage" && e.fromState === "allMessages") {
      this.expandedMessageTrigger = "expandedMessage";
    }
  }
  closeConversation() {
    this.expandedMessageTrigger = "allMessages";
  }

  closeConversationEnd(e) {
    if (e.toState === "allMessages" && e.fromState === "expandedMessage") {
      this.allMessagesTrigger = "allMessages";
    }
  }

  openProfile(uid) {
    this.profileTrigger = "show";
    this.selectedProfile = uid;
  }

  closeProfile() {
    this.profileTrigger = "void";
    this.selectedProfile = null;
  }
}
